import gql from 'graphql-tag';

import {
  DigitalBundleDetails,
  PurchasedDigitalBundleDetails,
} from '../fragments/digital-bundles';

export const digitalBundleCreate = gql`
  mutation digitalBundleCreate($input: DigitalBundleCreateInput!) {
    digitalBundleCreate(input: $input) {
      digital_bundle {
        ...DigitalBundleDetails
      }
    }
  }
  ${DigitalBundleDetails}
`;

export const digitalBundleUpdate = gql`
  mutation digitalBundleUpdate($input: DigitalBundleUpdateInput!) {
    digitalBundleUpdate(input: $input) {
      digital_bundle {
        ...DigitalBundleDetails
      }
    }
  }
  ${DigitalBundleDetails}
`;

export const purchasedDigitalBundlePhotosCreate = gql`
  mutation purchasedDigitalBundlePhotosCreate(
    $input: PurchasedDigitalBundlePhotosCreateInput!
  ) {
    purchasedDigitalBundlePhotosCreate(input: $input) {
      success
      purchased_digital_bundle {
        ...PurchasedDigitalBundleDetails
      }
    }
  }
  ${PurchasedDigitalBundleDetails}
`;
